import { render, staticRenderFns } from "./CommonElectron.vue?vue&type=template&id=39040cf8&scoped=true&"
import script from "./CommonElectron.vue?vue&type=script&lang=js&"
export * from "./CommonElectron.vue?vue&type=script&lang=js&"
import style0 from "./CommonElectron.vue?vue&type=style&index=0&id=39040cf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39040cf8",
  null
  
)

export default component.exports